import React from "react";
import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import kokoImg from "../screens/koko.jpg";
import emblemLogo from "../assets/logo-vertical.png";

const PromoVideo = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language.startsWith("ar");

  return (
    <Box
      id="promo-video"
      sx={{
        pt: 0,
        pb: 0,
        background: "linear-gradient(180deg, #080808 0%, #060606 100%)",
        position: "relative",
        overflow: "hidden",
        width: "100%",
      }}
    >
      {/* Background ambient glow behind video */}
      <Box
        sx={{
          position: "absolute",
          width: { xs: "350px", md: "800px" },
          height: { xs: "350px", md: "500px" },
          background: "radial-gradient(circle, rgba(255, 174, 0, 0.05) 0%, rgba(255, 174, 0, 0) 70%)",
          filter: "blur(90px)",
          top: "40%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      />

      {/* Edge-to-Edge Bezel-less Widescreen Image Player with Overlay */}
      <Box
        component={motion.div}
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        sx={{
          width: "100vw",
          maxWidth: "100%",
          position: "relative",
          zIndex: 1,
          overflow: "hidden",
          aspectRatio: { xs: "4/3", sm: "16/9" },
          maxHeight: "75vh",
          background: "#000000",
          borderTop: "1px solid rgba(255, 174, 0, 0.1)",
          borderBottom: "1px solid rgba(255, 174, 0, 0.1)",
          boxShadow: "0 20px 60px rgba(0,0,0,0.9)",
        }}
      >
        <Box
          component="img"
          src={kokoImg}
          alt="TowHelp Promo"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
          }}
        />

        {/* Overlay Content */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 3,
            background: "rgba(0, 0, 0, 0.5)", // Dark overlay for text readability
            px: 3,
            textAlign: "center",
          }}
        >
          <Box
            component={motion.img}
            src={emblemLogo}
            alt="TowHelp Logo"
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            sx={{
              height: { xs: 180, sm: 260, md: 360 },
              mb: { xs: -3, sm: -5, md: -8 },
              filter: "drop-shadow(0 4px 20px rgba(0, 0, 0, 0.95))",
            }}
          />
          <Typography
            component={motion.p}
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            variant="body1"
            sx={{
              color: "rgba(255, 255, 255, 0.95)",
              maxWidth: "700px",
              mx: "auto",
              fontSize: { xs: "1.1rem", sm: "1.5rem", md: "2.2rem" },
              fontWeight: 700,
              lineHeight: 1.6,
              fontFamily: "Ozen, Poppins",
              textShadow: "0 4px 15px rgba(0, 0, 0, 0.9)",
            }}
          >
            {isRTL
              ? "أنت مش لوحدك على الطريق"
              : "Your trusted companion on the road"}
          </Typography>
        </Box>

        {/* Theatrical Vignette Overlay Shadows */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "15%",
            background: "linear-gradient(to bottom, rgba(8, 8, 8, 1) 0%, rgba(8, 8, 8, 0) 100%)",
            pointerEvents: "none",
            zIndex: 4,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "15%",
            background: "linear-gradient(to top, rgba(6, 6, 6, 1) 0%, rgba(6, 6, 6, 0) 100%)",
            pointerEvents: "none",
            zIndex: 4,
          }}
        />
      </Box>
    </Box>
  );
};

export default PromoVideo;
